<div class="event-manager-base">
  <div class="wizard-header">
    <div class="wizard-step" *ngFor="let label of ['Evento', 'Voluntário', 'Função', 'Agendamento', 'Confirmação']; let i = index"
         [class.active]="step === i" [class.completed]="step > i"
         [class.clickable]="canGoToStep(i)"
         (click)="canGoToStep(i) && goToStep(i)">
      <div class="step-index">{{ i + 1 }}</div>
      <div class="step-label">{{ label }}</div>
      <div class="step-bar" *ngIf="i < 4"></div>
    </div>
  </div>

  <!-- Mobile header -->
  <div class="wizard-header-mobile" *ngIf="isMobileScreen">
    <button class="wizard-mobile-arrow" (click)="goToStep(step-1)" [disabled]="step === 0  || !canGoToStep(step-1)">
      &#8592;
    </button>
    <div class="wizard-mobile-step-index">{{ step + 1 }}</div>
    <div class="wizard-mobile-step-label">
      {{ ['Evento', 'Voluntário', 'Função', 'Agendamento', 'Confirmação'][step] }}
    </div>
    <button class="wizard-mobile-arrow" (click)="goToStep(step+1)" [disabled]="step === 4 || !canGoToStep(step+1)">
      &#8594;
    </button>
  </div>

  <div class="wizard-content">
    <ng-container [ngSwitch]="step">
      <app-event-step *ngSwitchCase="0"
        (eventSelected)="onEventStepSelected($event)">
      </app-event-step>

      <app-volunteer-step *ngSwitchCase="1"
        (volunteerSelected)="onVolunteerSelected($event)"
        (iniciarLocalDefinido)="onIniciarLocalDefinido($event)">
      </app-volunteer-step>

      <app-job-step *ngSwitchCase="2"
        [eventId]="selectedEvent?.uuid || null"
        (jobSelected)="onJobSelected($event)">
      </app-job-step>

      <app-schedule-step *ngSwitchCase="3"
        [event]="selectedEvent"
        [volunteer]="selectedVolunteer"
        [jobLocation]="selectedJobLocation"
        (back)="step = 2"
        (confirm)="onScheduleConfirmed($event)">
      </app-schedule-step>

      <app-result-step *ngSwitchCase="4"
        [success]="staffCreated"
        [message]="resultMessage"
        (finish)="onResultFinish($event)">
      </app-result-step>
    </ng-container>
  </div>
</div>
